// extracted by mini-css-extract-plugin
export default {"login-form-container":"LoginForm_login-form-container__4JvXr","link-text":"LoginForm_link-text__9OCK1"};